import { CoreIcon } from '../core-icon';
import scanSVG from '../../assets/icons/scan.svg';
import type { IconProps } from '../core-icon';

export const ScanIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={scanSVG} {...props} />;
};
